// @ts-nocheck
import { graphql } from "@apollo/client/react/hoc";
import { message } from "antd";
import { UPDATE_RESPONSE } from "modules/poc-dashboard/graphql/surveyreportQuery.gql";

export const withUpdateResponse = Component =>
  graphql(UPDATE_RESPONSE, {
    props: ({ mutate, history }) => ({
      updateResponse: async values => {
        try {
          const {
            data: { updateResponse }
          } = await mutate({
            variables: {
              ...values
            }
          });

          message.destroy();
          message.success('Grades updated!');
          return updateResponse.response;
        } catch (e) {
          message.destroy();
          message.error("Failed To update response");
          console.error("ReportOperations -> withUpdateResponse", e)
        }
      }
    })
  })(Component);